import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "rowTemplate", "values"]
  static values = { valueless: Array }

  toggleValues(event) {
    const row = event.target.closest("[data-condition-row]")
    const values = row.querySelector("[data-conditions-editor-target='values']")
    if (values) values.classList.toggle("invisible", this.valuelessValue.includes(event.target.value))
  }

  addRow(event) {
    event.preventDefault()
    const index = this.listTarget.children.length
    const html = this.rowTemplateTarget.innerHTML.replaceAll("NEW_INDEX", index)
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  removeRow(event) {
    event.preventDefault()
    event.target.closest("[data-condition-row]").remove()
    this.reindex()
  }

  reindex() {
    this.listTarget.querySelectorAll("[data-condition-row]").forEach((row, i) => {
      row.querySelectorAll("[name]").forEach((field) => {
        field.name = field.name.replace(/\[conditions\]\[\d+\]/, `[conditions][${i}]`)
      })
    })
  }
}
